import * as React from "react"
import { VisibilityContext } from "react-horizontal-scrolling-menu"
import { CircleArrowIcon } from "../../common/icons/circle-arrow-icon"

export const LeftArrow = ({ left = "10px" }) => {
  const { isFirstItemVisible, scrollPrev } = React.useContext(VisibilityContext)

  return (
    <CircleArrowIcon
      directionIcon="left"
      position="absolute"
      zIndex={100000}
      left={left ?? "10px"}
      bottom="31%"
      visibility={isFirstItemVisible ? "hidden" : "visible"}
      disabled={isFirstItemVisible}
      onClick={() => scrollPrev()}
    />
  )
}
